import { GlobalToken, Grid, theme as antdTheme } from "antd";
import type { CustomToken } from "theme";
import { useIsMobile } from "./useIsMobile";

export const useAntTheme = () => {
  const { useToken } = antdTheme;
  const { token: theme } = useToken();
  const breakpoint = Grid.useBreakpoint();
  const { isMobile, orientation } = useIsMobile();
  return {
    theme: theme as GlobalToken & CustomToken,
    isMobile,
    orientation,
    breakpoint,
    colorPrimary: theme.colorPrimary,
  };
};
